export interface RecruitmentLocale {
    locale: string | null;
}

export const DefaultRecruitmentLocale: RecruitmentLocale = {
    locale: null,
};
